import { Coordinates } from '@collector/shared-ui-domain'
import PossessionAwayDangerousAttack from '@collector/shared-ui-domain/assets/rugby/possession-away-dangerous-attack.svg'
import PossessionAwayDefault from '@collector/shared-ui-domain/assets/rugby/possession-away-default.svg'
import PossessionHomeDangerousAttack from '@collector/shared-ui-domain/assets/rugby/possession-home-dangerous-attack.svg'
import PossessionHomeDefault from '@collector/shared-ui-domain/assets/rugby/possession-home-default.svg'
import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import {
  GetPossessionSvgOpts,
  IncidentsRequirePointingPositionConfig,
} from '../../../configuration/incidentsRequirePointingPositionConfig'
import {
  defaultCoordinatesTransform,
  FIELD_LENGTH,
  getBallContestPossessionSvg,
  getInPossessionPossessionSvg,
  isWithinRedZones,
  isWithinTryArea,
  isWithinTryAreas,
  LINE_THRESHOLD,
  TRY_AREA_X_COORDINATE_THRESHOLD,
} from '../../configuration'

export const incidentsRequirePointingPositionConfig: IncidentsRequirePointingPositionConfig<
  RugbyUnionIncidentId,
  RugbyUnionEventStatusId
> = {
  pointingPositionIncidents: {
    [RugbyUnionIncidentId.Try]: {
      transformCoordinates: (coordinates, teamSide) => {
        let x: number
        if (isWithinTryArea(teamSide, coordinates.x)) {
          x = Math.round(coordinates.x)
        } else {
          x =
            teamSide === 'home'
              ? Math.round(FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD)
              : Math.round(TRY_AREA_X_COORDINATE_THRESHOLD)
        }
        const y = coordinates.y

        return { x, y }
      },
    },
    [RugbyUnionIncidentId.ConversionAttempt]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.PenaltyAwarded]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.DropGoal]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.DropGoalMissed]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.Maul]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.Scrum]: {
      transformCoordinates: (coordinates, teamSide) =>
        defaultCoordinatesTransform(coordinates, teamSide),
    },
    [RugbyUnionIncidentId.Lineout]: {
      transformCoordinates: ({ x, y }) => {
        const minX = TRY_AREA_X_COORDINATE_THRESHOLD
        const maxX =
          FIELD_LENGTH - TRY_AREA_X_COORDINATE_THRESHOLD - LINE_THRESHOLD
        const clampedX = Math.round(Math.max(minX, Math.min(x, maxX)))

        return {
          x: clampedX,
          y: y > 50 ? FIELD_LENGTH : 1,
        }
      },
    },
  },
  excludedIncidentEventStatuses: [
    RugbyUnionEventStatusId.Halftime,
    RugbyUnionEventStatusId.ExtratimeHalftime,
    RugbyUnionEventStatusId.WaitingForPenalty,
  ],
  getIncidentIdForCoordinateX(
    event: MouseEvent,
    coordinate: Coordinates['x'],
  ): RugbyUnionIncidentId | null {
    if (event.type === 'contextmenu') {
      if (!isWithinTryAreas(coordinate)) return RugbyUnionIncidentId.Ruck
    } else {
      if (isWithinRedZones(coordinate)) return RugbyUnionIncidentId.EntryInto22
      else return RugbyUnionIncidentId.InPossession
    }
    return null
  },
  getPossessionSvg({ isAway }: GetPossessionSvgOpts, incidentId, coordinate) {
    switch (incidentId) {
      case RugbyUnionIncidentId.Ruck:
        return getBallContestPossessionSvg(coordinate, isAway)
      case RugbyUnionIncidentId.InPossession:
        return getInPossessionPossessionSvg(coordinate, isAway)
      case RugbyUnionIncidentId.EntryInto22:
        return isAway
          ? PossessionAwayDangerousAttack
          : PossessionHomeDangerousAttack
      default:
        return isAway ? PossessionAwayDefault : PossessionHomeDefault
    }
  },
}
